import React from 'react';
import { LangSelectProfile } from 'config';
import { components, OptionProps } from 'react-select';
import { Icon } from 'view/atoms';
import { check } from 'static/icons/resizable';

export const CustomOption =
  (label: keyof LangSelectProfile) =>
  (props: OptionProps<LangSelectProfile, false>) => {
    const { data, isSelected, innerProps, ...rest } = props;

    const testId = `dropdownOption-${String(data[label])
      .replace(/\s+/g, '-')
      .toLowerCase()}`;

    const patchedInnerProps = {
      ...(innerProps as Record<string, unknown>),
      'data-testid': testId,
    } as React.HTMLAttributes<HTMLDivElement>;

    return (
      <components.Option
        {...rest}
        innerProps={patchedInnerProps}
        data={data}
        isSelected={isSelected}
      >
        {data[label]}
        {isSelected && <Icon src={check} alt='check' />}
      </components.Option>
    );
  };
